<template>
  <div>
    <div
      class=""
      style="width: 100%"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="bg-white !border-b border-black/10 flex itmems-center justify-between px-3 !py-2">
        <div>
          <div class="text-lg text-black-700 font-[500]">Payment Integration List</div>
        </div>
        <div>
          <button
            class="!px-4 !py-1.5 !text-xs !text-white !bg-brand-500 !rounded-md"
            round
            @click="integrations()"
          >
            Integrations
          </button>
        </div>
      </div>
      <el-row :gutter="12">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="table-container">
          <template v-if="getIntegratedList && getIntegratedList.cred_details">
            <el-table
              :data="pageconfiguration(getIntegratedList.cred_details)"
              class="!mx-3"
              border
              style="margin: 0 auto; width: 98.5%; margin-top: 10px"
            >
              <el-table-column prop="accountName" label="Alias Name" />
              <el-table-column prop="pgType" label="PG Name" />
              <el-table-column prop="status" label="Status" />
              <el-table-column label="WebHook URL">
                <template slot-scope="scope">
                  <span v-if="scope.row.pgType === 'SWIREPAY'">
                    {{
                      `${paymentGatewayApiUrl}/sp/${scope.row.pgAccountId}/${scope.row.reference_id}`
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Actions">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      Actions
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <a @click="handleEdit(scope.row)">
                        <el-dropdown-item>Edit</el-dropdown-item>
                      </a>
                      <!-- <a @click="handleShare(scope.row)"><el-dropdown-item>Share</el-dropdown-item></a> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <center>
              <el-pagination
                class="mt-[10px]"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="paginationProps"
                :page-size="pageSize"
                :pager-count="5"
                layout="prev, pager, next, jumper,sizes, total"
                :total="total"
                small
              ></el-pagination>
              <div style="margin-top: 10px">Total {{ getIntegratedList.cred_details.length }}</div>
            </center>
          </template>
          <template v-else>
            <div class="no-data-card">
              <div class="text-lg text-black-700 font-[500]">Payment Gateways Not Configured</div>
              <p>Please add at least one payment gateway to continue accepting payments.</p>
              <button
                class="!px-4 !py-1.5 !text-xs !text-white !bg-brand-500 !rounded-md"
                round
                @click="integrations()"
              >
                Configure Now
              </button>
            </div>
          </template>
        </el-col>
      </el-row>
    </div>

    <dialog-component
      :title="`${ruleForm.pgType} Payment Gateway Details`"
      :containerWidth="'50%'"
      top="5vh"
      style="color: var(--brand-500) !important"
      :visible="stripeApiDialog"
      @before-close="stripeApiDialog = false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="Alias Name" prop="accountName">
          <el-input v-model="ruleForm.accountName"></el-input>
        </el-form-item>
        <el-form-item label="API Key" prop="apiKey">
          <el-input v-model="ruleForm.apiKey"></el-input>
        </el-form-item>
        <el-form-item label="Public Key" prop="publicKey">
          <el-input v-model="ruleForm.publicKey"></el-input>
        </el-form-item>
        <el-form-item label="status" prop="Status">
          <el-select placeholder="Status" v-model="ruleForm.status">
            <el-option key="pay_ACTIVE" label="ACTIVE" value="ACTIVE"></el-option>
            <el-option key="pay_INACTIVE" label="INACTIVE" value="INACTIVE"></el-option>
          </el-select>
        </el-form-item>
        <!--- Forte System required Options start-->
        <el-form-item label="Organization Id" prop="orgId" v-if="ruleForm.pgType === 'FORTE'">
          <el-input v-model="ruleForm.otherConfigurations.orgId"></el-input>
        </el-form-item>
        <el-form-item label="Location Id" prop="locId" v-if="ruleForm.pgType === 'FORTE'">
          <el-input v-model="ruleForm.otherConfigurations.locId"></el-input>
        </el-form-item>
        <br />
        <el-switch
          style="display: block"
          v-model="ruleForm.isLive"
          active-color="var(--brand-500)"
          inactive-color="var(--black-200)"
          active-text="Live"
          inactive-text="Sandbox"
        ></el-switch>
        <!--- Forte System required Options end  -->
        <el-form-item>
          <el-checkbox v-model="ruleForm.isDefault">Make it default payment system</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="updateForm('ruleForm')">Update</el-button>
        <!-- <el-button @click="resetForm('ruleForm')">Reset</el-button> -->
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import appConfig from '@/config/app.js';

  export default {
    name: 'PGInformationList',
    components: {},
    data() {
      //added
      return {
        paymentGatewayApiUrl: appConfig.PAYMENT_GATEWAY_URL,
        loading: false,
        stripeApiDialog: false,
        paginationProps: [10, 20, 50],
        paymentInfo: {},
        currentPage: 1,
        pageSize: 10,
        total: 0,
        ruleForm: {
          id: '',
          stripeKey: '',
          apiKey: '',
          publicKey: '',
          isDefault: false,
          accountName: '',
          status: 'ACTIVE',
          isLive: false,
          otherConfigurations: {
            orgId: '',
            locId: '',
          },
        },
        rules: {
          accountName: [
            {
              required: true,
              message: 'Please enter Alias name',
              trigger: 'blur',
            },
          ],
          stripeKey: [
            {
              required: true,
              message: 'Please enter api key',
              trigger: 'blur',
            },
          ],
          apiKey: [{ required: true, message: 'Please enter api key', trigger: 'blur' }],
          publicKey: [
            {
              required: true,
              message: 'Please enter public key',
              trigger: 'blur',
            },
          ],
        },
      };
      //upto this added
    },
    computed: {
      ...mapGetters('paymentGateway', [
        'getPlansData',
        'getActivePaymentSystems',
        'getPaymentGatewayInfo',
        'getUpdateSystemInfo',
        'getUpdateSystemInfoByTxnId',
        'getIntegratedList',
      ]),
      ...mapGetters('auth', ['getActiveWorkspace', 'getAuthenticatedUser']),
    },
    created() {},
    mounted() {
      this.getActivePaymentSystemsData();
    },
    methods: {
      async integrations() {
        this.$router.push({
          path: `/${
            this.getActiveWorkspace.company_id
          }/configuration/paymentSystems/add?_t=${Date.now()}`,
        });
      },
      handleSizeChange(val) {
        this.pageSize = val;
      },
      async paymentInit(info) {
        this.loading = true;
        await this.$store.dispatch('paymentGateway/fetchPaymentInit', {
          email: this.getAuthenticatedUser.email,
          client_id: this.getActiveWorkspace.company_id,
        });

        if (this.getPaymentGatewayInfo && this.getPaymentGatewayInfo.ivKey) {
          this.stripeApiDialog = true;
          this.paymentInfo = info;
        }
        this.loading = false;
      },

      async updateForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            await this.$store.dispatch('paymentGateway/fetchPaymentInit', {
              email: this.getAuthenticatedUser.email,
              client_id: this.getActiveWorkspace.company_id,
            });
            const keys = this.$CryptoJS.AES.encrypt(
              JSON.stringify(this.ruleForm),
              this.getPaymentGatewayInfo.ivKey
            ).toString();
            let requestInfo = {
              pgType: this.ruleForm.pgType,
              type: 'APP',
              status: this.ruleForm.status, //"ACTIVE",
              crypto: keys,
              accountName: this.ruleForm.accountName,
              isDefault: this.ruleForm.isDefault,
            };
            this.loading = true;
            await this.$store.dispatch('paymentGateway/updateInfoByTxnId', {
              accountId: this.getPaymentGatewayInfo._id,
              txnId: this.ruleForm.id,
              data: requestInfo,
            });

            if (this.getUpdateSystemInfoByTxnId) {
              this.$notify({
                title: 'Success',
                message: `Payment System Info Updated`,
                type: 'success',
              });
              this.$router.push({
                path: `/${
                  this.getActiveWorkspace.company_id
                }/configuration/paymentSystems?_t=${Date.now()}`,
              });
            }
            this.stripeApiDialog = false;
            this.paymentInfo = {};
            this.ruleForm = {
              stripeKey: '',
              apiKey: '',
              publicKey: '',
              isDefault: false,
              accountName: '',
              status: 'ACTIVE',
              id: '',
              isLive: false,
              otherConfigurations: {
                orgId: '',
                locId: '',
              },
            };
            this.loading = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      pageconfiguration(data) {
        this.total = data.length;
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        const pageItems = data.slice(startIndex, endIndex);
        return pageItems;
      },
      async getActivePaymentSystemsData() {
        this.loading = true;
        await this.$store.dispatch(
          'paymentGateway/fetchInitSystemsData',
          this.getActiveWorkspace.company_id
        );
        this.loading = false;
      },

      handleEdit(row) {
        this.stripeApiDialog = true;
        this.paymentInfo = row;
        const decrypted = this.$CryptoJS.AES.decrypt(row.crypto, row.ivKey);
        const info = decrypted.toString(this.$CryptoJS.enc.Utf8);
        let data = JSON.parse(info);
        // console.log("Dta", data);
        this.ruleForm = {
          id: row.reference_id,
          stripeKey: '',
          apiKey: data.apiKey,
          publicKey: data.publicKey,
          isDefault: row.isDefault,
          accountName: row.accountName,
          status: row.status,
          pgType: row.pgType,
          isLive: data.isLive ? data.isLive : false,
          otherConfigurations: {
            orgId: data ? data.otherConfigurations?.orgId : '',
            locId: data ? data.otherConfigurations?.locId : '',
          },
        };
      },
      // this.ruleForm={...this.ruleForm,...info}
    },
  };
</script>
<style lang="scss" scoped>
  .cropper {
    height: 600px;
    width: 600px;
    background: #ddd;
  }

  .paymentSty {
    cursor: pointer;
  }

  .image-fit {
    //width:68%;
    height: 100%;
  }

  .clearfix {
    padding-bottom: 2rem;
  }

  .integration-button-container {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .no-data-card {
    background: #fff;
    padding: 40px 30px;
    border-radius: 12px;
    // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 100%;
  }

  .no-data-card h1 {
    font-size: 24px;
    margin-bottom: 10px;
    color: #ff5252;
  }

  .no-data-card p {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
  }

  // .no-data-card button {
  //   background-color: #007bff;
  //   color: #fff;
  //   padding: 10px 20px;
  //   border: none;
  //   border-radius: 6px;
  //   cursor: pointer;
  //   font-size: 14px;
  //   transition: background 0.3s;
  // }

  // .no-data-card button:hover {
  //   background-color: #0056b3;
  // }
</style>
